import { IDialogContentStyles } from '@fluentui/react';
import { HostAppColors } from './HostAppColors';

export const getDialogTitleStyle = (appColors: HostAppColors): Partial<IDialogContentStyles> => {
  return {
    title: {
      color: appColors.themeDark
    }
  };
};
